import type { AccountInfo, AuthenticationResult, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import type { Decorator } from "@storybook/react-vite";
import { msalInstance } from "../auth/msal.ts";
import { mocks } from "./microsoft.mocks.ts";
import { createFaker } from "./mocks.ts";

const faker = createFaker("msal");

const account: AccountInfo = {
    tenantId: mocks.tenant.id,
    username: "Sam Altam",
    name: "Sam Altam",
    homeAccountId: faker.git.commitSha(),
    environment: "local",
    localAccountId: faker.git.commitSha()
};

const authenticationResult: AuthenticationResult = {
    tenantId: mocks.tenant.id,
    idToken: faker.git.commitSha(),
    accessToken: faker.git.commitSha(),
    authority: faker.company.name(),
    scopes: [],
    tokenType: "Camusel",
    idTokenClaims: {
        roles: ["Assessor"]
    },
    account,
    uniqueId: faker.git.commitSha(),
    fromCache: true,
    expiresOn: faker.date.anytime(),
    correlationId: faker.git.commitSha()
};

export function injectMockMsal(publicClientApplication: PublicClientApplication) {
    publicClientApplication.acquireTokenSilent = () => {
        return Promise.resolve(authenticationResult);
    };

    publicClientApplication.getActiveAccount = () => {
        return account;
    };

    publicClientApplication.getAllAccounts = () => {
        return [account];
    };

    publicClientApplication.logout = async () => {};
}

export const msalDecorator: Decorator = Story => {
    injectMockMsal(msalInstance);

    return (
        <MsalProvider instance={msalInstance}>
            <Story />
        </MsalProvider>
    );
};
